import { styled, TableCell, TableCellProps } from '@mui/material'
import { ReactNode } from 'react'

interface HeaderTableCellProps extends TableCellProps {
  children: ReactNode
}

export const HeaderTableCell = ({
  children,
  ...rest
}: HeaderTableCellProps) => (
  <StyledHeaderTableCell size='small' {...rest}>
    {children}
  </StyledHeaderTableCell>
)

const StyledHeaderTableCell = styled(TableCell)(({ theme }) =>
  theme.palette.mode === 'dark'
    ? {
        backgroundColor: 'none',
        textTransform: 'uppercase',
        height: '3rem',
        borderBottom: `0.5px solid ${theme.palette.divider}`,
        borderTop: `0.5px solid ${theme.palette.divider}`,
      }
    : {
        backgroundColor: theme.palette.grey[200],
        textTransform: 'uppercase',
        height: '3rem',
        borderBottom: `0.5px solid ${theme.palette.divider}`,
        borderTop: `0.5px solid ${theme.palette.divider}`,
      },
)
